import './App.css';
import Timer from './Timer';
import Settings from './Settings';
import {useState} from 'react';
import SettingsContext from './SettingsContext';
import Quotes from './Quotes';

function App() {
  const [showSettings, setShowSettings] = useState(false);
  const [showQuotes, setShowQuotes] = useState(true);
  const [workMinutes, setWorkMinutes] = useState(45);
  const [breakMinutes, setBreakMinutes] = useState(15);

  return (
    <div>
      <div className={`animated-quotes ${showQuotes ? 'show' : ''}`}>
          <Quotes />
        </div>
      <main>        
        <SettingsContext.Provider value={{
          showSettings,
          setShowSettings,
          workMinutes,
          breakMinutes,
          setWorkMinutes,
          setBreakMinutes,
          showQuotes,
          setShowQuotes,
        }}>
          <Timer />
          {showSettings && <Settings />}
        </SettingsContext.Provider>
      </main>
    </div>
  );
}

export default App;
